module.exports = __webpack_public_path__ + "25a281516c7ca8488c4969ea3da624d2.png";